import { Exact } from 'common/repositories';
import { Filter } from 'common/repositories/common.model';
import { useRouter } from 'next/router';
import qs from 'qs';
import React from 'react';

export function getFilterParams(filters: Filter[]) {
  return (
    filters &&
    filters.reduce((prev, next) => {
      if (next.value !== undefined && next.value !== null) {
        return {
          ...prev,
          [next.name]: next.value,
        };
      }
      return prev;
    }, {})
  );
}

export function useApplyQueryFilter<
  QueryData,
  QueryInput extends Exact<{ params: Exact<{ filter?: string | null }> }>,
>(
  getFilterMeta: (data: QueryData) => Filter[] | undefined,
  // exclude?: string[],
) {
  const { query } = useRouter();
  const [filters, setFilters] = React.useState<Filter[] | undefined>();

  const filter = React.useMemo(() => {
    return (
      filters &&
      filters.reduce((prev, next) => {
        if (next.value !== undefined && next.value !== null) {
          return {
            ...prev,
            [next.name]: next.value,
          };
        }
        return prev;
      }, {})
    );
  }, [filters]);

  const parsedQuery = React.useMemo(() => {
    return qs.parse(query as unknown as string);
  }, [query]);

  const values = React.useMemo(() => {
    return {
      input: {
        params: {
          filter: (filter as string) || parsedQuery.filter || {},
        },
      } as unknown as QueryInput,
      onSuccess(data: QueryData) {
        setFilters(getFilterMeta(data));
      },
      extra: {
        filters,
        setFilters,
      },
    };
  }, [filter, filters, getFilterMeta, parsedQuery.filter]);

  return values;
}
